/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';

import { CurrentUserProvider } from './components/useCurrentUser';

import Store from './components/Store';
import RelayEnv from './RelayEnv';
import ErrorBoundary from './components/ErrorBoundary';
import './styles/index.css';

window.Store = Store;
window.RelayEnv = RelayEnv;

const container = document.getElementById('root');
const root = createRoot(container);

console.log('HERE I AM');
root.render(
  <ErrorBoundary>
    <CurrentUserProvider>
      <App />
    </CurrentUserProvider>
  </ErrorBoundary>,
);
